<template>
  <div class="row">
    <div class="col-lg-12 col-xs-12">
      <div class="p-2">
        <h2 class="mb-3">{{ plural }}</h2>
        <hr />
        <div class="row">
          <div class="col-lg-6 col-xs-12">
            <div v-for="(apply, index) in appliesCurrent" :key="apply.id">
              <div class="candidate_list">
                <div class="row color-primary p-3">
                  <div class="col-lg-4 col-xs-12">
                    <div
                      v-if="apply.image == ''"
                      class="avatar_thumb bg-black"
                    ></div>
                    <img
                      v-if="apply.image != ''"
                      :src="apply.image"
                      class="shadow_bar avatar_thumb"
                    />
                  </div>
                  <div class="col-lg-8 col-xs-12">
                    <div @click="removeApply(index)" class="close-alt">
                      <font-awesome-icon
                        :icon="['fas', 'trash-alt']"
                      ></font-awesome-icon>
                    </div>
                    <span class="f25">
                      <b>{{ apply.name.split(" ")[0] }}</b>
                    </span>
                    <br />
                    <a
                      class="f12 color-primary"
                      :href="`mailto:${apply.email}`"
                      >{{ apply.email }}</a
                    >
                    <br />
                    <span v-if="apply.answered_all" class="f12 color-black">
                      CONDIDATO(A) JÁ RESPONDEU <br />{{
                        questions.length > 1
                          ? "ESTAS PERGUNTAS"
                          : "ESTA PERGUNTA"
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xs-12">
            <div v-show="questions.length > 0">
              <Questions :questions_record="questions" />
            </div>
            <div class="mt-3" v-if="bigfive">
              <span
                >O CANDIDATO TAMBÉM RECEBERÁ O QUESTIONÁRIO<br />
                DO TESTE DO BIGFIVE</span
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-6 p-0 m-0 center">
      <button
        type="button"
        class="btn radius-0 full btn btn-outline-success"
        @click="sendQuestions"
      >
        ENVIAR AS PERGUNTAS
      </button>
    </div>
    <div class="col-lg-6 p-0 m-0 center">
      <button
        @click="$emit('close')"
        type="button"
        class="radius-0 full btn btn-outline-danger"
      >
        CANCELAR ENVIO
      </button>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Questions from "./Questions.vue";

export default {
  props: ["selective_process_uid", "applies", "bigfive"],
  components: { Questions },
  data: () => ({
    questions: [],
    appliesCurrent: [],
  }),
  mounted() {
    this.appliesCurrent = this.applies;

    axios
      .get(`/selected_questions/questions/${this.selective_process_uid}`)
      .then((response) => {
        this.questions = response.data.questions;
        let questions_ids = this.questions.map((question) => question.id);
        for (let apply of this.appliesCurrent) {
          let count = apply.answers.filter((answer) =>
            questions_ids.includes(answer.question_id)
          ).length;
          apply.answered_all = count == questions_ids.length ? true : false;
        }
      });
  },
  computed: {
    plural() {
      let text = [
        "Os Candidato(a)s receberão esta(s) pergunta(s)",
        "O Candidato(a) recebera esta(s) pergunta(s)",
      ];

      return this.applies.length > 1 ? text[0] : text[1];
    },
  },
  methods: {
    removeApply(index) {
      let conf = confirm(
        "Tem certeza que deseja tirar esse Candidato(a) da lista?"
      );
      if (!conf) return;

      this.appliesCurrent.splice(index, 1);
    },
    sendQuestions() {
      let candidates_ids = [];
      for (let apply of this.appliesCurrent)
        candidates_ids.push(apply.candidate_id);

      let selected_questions = {
        selective_process_uid: this.selective_process_uid,
        candidates_ids,
      };
      axios
        .post("/selected_questions/candidate", { selected_questions })
        .then((response) => {
          if (response.data.status) {
            this.$toast.success("Perguntas enviadas com sucesso!");
          }
        });
      this.$emit("close");
    },
  },
};
</script>